export const USER_REQUEST = 'USER_REQUEST';
export const HR_USER_REQUEST = 'HR_USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const USER_SAVE_USEDESK_TOKEN = 'USER_SAVE_USEDESK_TOKEN';
export const USER_SAVE = 'USER_SAVE';
